import { render, staticRenderFns } from "./DemoDialogContent.vue?vue&type=template&id=4a1eb989&scoped=true"
import script from "./DemoDialogContent.vue?vue&type=script&lang=ts"
export * from "./DemoDialogContent.vue?vue&type=script&lang=ts"
import style0 from "./DemoDialogContent.vue?vue&type=style&index=0&id=4a1eb989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1eb989",
  null
  
)

export default component.exports